<button
    mat-button
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="rootMenu"
    matTooltip="Streams"
>
    <mat-icon>expand_more</mat-icon>
    <span> Streams : {{ (stream$ | async)?.name }}</span>
</button>

<mat-menu #rootMenu="matMenu">
    @if (
        {
            streams: streams$ | async,
            activeStream: stream$ | async,
        };
        as data
    ) {
        <div class="menu">
            @for (stream of data.streams; track stream) {
                <span>
                    @if (stream.children && stream.children.length > 0) {
                        <span>
                            <button
                                mat-menu-item
                                [matTooltip]="stream.description"
                                [matMenuTriggerFor]="childMenu"
                                (click)="viewStream(stream)"
                                [class.active]="stream.id === data.activeStream?.id"
                            >
                                <mat-icon>{{ stream.private ? "lock" : "grid_view" }}</mat-icon>
                                <span>{{ stream.name }}</span>
                            </button>
                            <mat-menu #childMenu="matMenu" [overlapTrigger]="false">
                                <div class="menu">
                                    @for (child of stream.children; track child) {
                                        <span>
                                            <!-- Handle leaf node menu items -->
                                            <button
                                                mat-menu-item
                                                [matTooltip]="child.description"
                                                (click)="viewStream(child)"
                                                [class.active]="child.id === data.activeStream?.id"
                                            >
                                                <mat-icon>{{
                                                    stream.private ? "lock" : "grid_view"
                                                }}</mat-icon>
                                                <span>{{ child.name }}</span>
                                            </button>
                                        </span>
                                    }
                                </div>
                            </mat-menu>
                        </span>
                    } @else {
                        <button
                            mat-menu-item
                            [matTooltip]="stream.description"
                            (click)="viewStream(stream)"
                            [class.active]="stream.id === data.activeStream?.id"
                        >
                            <mat-icon>{{ stream.private ? "lock" : "grid_view" }}</mat-icon>
                            <span>{{ stream.name }}</span>
                        </button>
                    }
                    <ng-template #leaf>
                        <button
                            mat-menu-item
                            [matTooltip]="stream.description"
                            (click)="viewStream(stream)"
                            [class.active]="stream.id === data.activeStream?.id"
                        >
                            <mat-icon>{{ stream.private ? "lock" : "grid_view" }}</mat-icon>
                            <span>{{ stream.name }}</span>
                        </button>
                    </ng-template>
                </span>
            }
        </div>
    }
</mat-menu>
